module.exports = __webpack_public_path__ + "static/media/Combles_amenages_11_PV_RT_MAX.def55dc3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Combles_amenages_11_PV_RT_MAX.jpg
// module id = 1152
// module chunks = 0